import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "@product/scmp-sdk";

import { StyledImage } from "scmp-app/components/common/base-image/styles";
import { StyledContentBookmark } from "scmp-app/components/content/content-action-bar/styles";
import { EntityLink } from "scmp-app/components/entity-link";

type CoverProps = {
  $imageAspectRatio?: string;
};

export const Cover = styled.div<CoverProps>`
  ${StyledImage} {
    aspect-ratio: ${props => props.$imageAspectRatio ?? "3 / 2"};
  }

  ${theme.breakpoints.up("tablet")} {
    block-size: auto;
    margin-block-end: 0;
  }
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  position: relative;

  inline-size: 100%;
  block-size: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
  max-inline-size: 335px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: space-between;

  block-size: 100%;
  padding: 16px;

  background: #181a1e;
`;

export const TagAndHeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const StyledTagEntityLink = styled(EntityLink)`
  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledHeadlineEntityLink = styled(EntityLink)``;

export const Headline = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  &:hover {
    text-decoration: underline;
  }
`;

export const Footer = styled.div`
  color: #999999;
  font-size: 12px;
  font-family: ${fontRoboto};

  ${StyledContentBookmark} {
    path {
      fill: #ffffff;
    }
  }
`;
